import { c as _c } from "react/compiler-runtime";
import type { MatchLevel } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
const useMatchSignalLabels = () => {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "auditTrail.timeline.onboardingDecisionEvent.notVerifiedDetails.fieldValidations"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  let t1;
  if ($[1] !== t) {
    t1 = {
      phone: () => t(_temp),
      name: () => t(_temp2),
      address: () => t(_temp3),
      dob: () => t(_temp4),
      email: () => t(_temp5),
      ssn: () => t(_temp6),
      document: () => t(_temp7),
      businessName: () => t(_temp8),
      businessDba: () => t(_temp9),
      businessTin: () => t(_temp10),
      businessAddress: () => t(_temp11),
      businessBeneficialOwners: () => t(_temp12),
      businessPhoneNumber: () => t(_temp13)
    };
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const attributes = t1;
  let t2;
  if ($[3] !== t) {
    t2 = {
      exact: () => t(_temp14),
      no_match: () => t(_temp15),
      could_not_match: () => t(_temp16),
      partial: () => t(_temp17)
    };
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const levels = t2;
  let t3;
  if ($[5] !== attributes) {
    t3 = attribute => attributes[attribute]?.() ?? attribute;
    $[5] = attributes;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== levels) {
    t4 = level => levels[level]?.() ?? level;
    $[7] = levels;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = {
      getAttributeLabel: t3,
      getMatchLevelLabel: t4
    };
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default useMatchSignalLabels;
function _temp($) {
  return $.attributes.phone;
}
function _temp2($_0) {
  return $_0.attributes.name;
}
function _temp3($_1) {
  return $_1.attributes.address;
}
function _temp4($_2) {
  return $_2.attributes.dob;
}
function _temp5($_3) {
  return $_3.attributes.email;
}
function _temp6($_4) {
  return $_4.attributes.ssn;
}
function _temp7($_5) {
  return $_5.attributes.document;
}
function _temp8($_6) {
  return $_6.attributes.businessName;
}
function _temp9($_7) {
  return $_7.attributes.businessDba;
}
function _temp10($_8) {
  return $_8.attributes.businessTin;
}
function _temp11($_9) {
  return $_9.attributes.businessAddress;
}
function _temp12($_10) {
  return $_10.attributes.businessBeneficialOwners;
}
function _temp13($_11) {
  return $_11.attributes.businessPhoneNumber;
}
function _temp14($_12) {
  return $_12.matchLevel.exact;
}
function _temp15($_13) {
  return $_13.matchLevel.no_match;
}
function _temp16($_14) {
  return $_14.matchLevel.could_not_match;
}
function _temp17($_15) {
  return $_15.matchLevel.partial;
}